"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DGENOAUTH = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Panel_1 = require("../../components/Panel");
var Stack_1 = require("../../components/Stack");
exports.DGENOAUTH = (0, jsx_runtime_1.jsxs)(Panel_1.Panel, {
  children: [(0, jsx_runtime_1.jsx)(Panel_1.Header, {
    children: "NOT AUTHORIZED"
  }), (0, jsx_runtime_1.jsx)(Panel_1.Body, {
    children: (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
      gap: "medium"
    }, {
      children: [(0, jsx_runtime_1.jsxs)("div", {
        children: ["This component requires special authorization from UI Squad. However, all applications can freely use the normal ", (0, jsx_runtime_1.jsx)("a", __assign({
          href: "https://visualstackx.cj.com/?path=/story/data-datagrid--data-grid"
        }, {
          children: "DataGrid"
        })), " component."]
      }), (0, jsx_runtime_1.jsx)("div", {
        children: "Speak to UI Squad for more information."
      })]
    }))
  })]
});